import { useState, useEffect } from 'react'
import {
  URL_BACKEND,
  URL_PROMEDIOS_ASPIRANTES_INGLES,
  URL_PROMEDIOS_ASPIRANTES_INGLES_POR_CARRERA,
  URL_PROMEDIOS_INGLES_TODAS_CARRERAS
} from "../../api/url";
import { elToast } from "../../functions/alertas";


const usePromediosResultadosIngles = () => {

    const [loading, setLoading] = useState(true);
    const [carreras, setCarreras] = useState([]);
    const [ciclosExamen, setCiclosExamen] = useState([])
    const [ciclo, setCiclo] = useState('2022-2023')


    const traerCiclosExamen = () => {

        const datos = new FormData()
        datos.append('funcion', 'traerCiclosExamen');

        fetch(URL_BACKEND, {
          method: 'post',
          body: datos
        })
          .then(res => res.json())
          .then(setCiclosExamen)
    }


    const traerCarreras = () => {

        const body = new FormData();
        body.append( 'funcion', 'traerCarreras' )

        fetch( URL_BACKEND, {
        method: 'post',
        body
        })
        .then( r => r.json() )
        .then( setCarreras )
        .catch( () => alert('Error al obtener carreras') )
        .finally( () => setLoading( false ) )

    }


    const promediosAspirantesIngles = () => {

        elToast( "Generando reporte", "esperar" );

        const formData = new FormData();
        formData.append("ciclo", ciclo);

        fetch(URL_PROMEDIOS_ASPIRANTES_INGLES, {
            method: "POST",
            body: formData
        })
        .then((r) => r.blob())
        .then((d) => {
            const pdf = URL.createObjectURL(d);
            // window.open(pdf, "_blank");
            const anchor = document.createElement("a");
            anchor.download =
            "PROMEDIOS DE RESULTADOS DE ASPIRANTES EN INGLÉS";
            anchor.href = pdf;
            anchor.click();
        })
        .catch(() => alert("Error al generar reporte"));

        // .then((r) => r.json())
        // .then((d) => { console.log(d) })


    }



    // eslint-disable-next-line
    const promediosAspirantesInglesPorCarrera = (pk_carrera, nom_carrera) => {

        elToast( "Generando reporte", "esperar" );
            // eslint-disable-next-line
        const nombre_carrera = nom_carrera.toUpperCase();

        const formData = new FormData();
        formData.append("pk_carrera", pk_carrera);
        formData.append("ciclo", ciclo);

        fetch(URL_PROMEDIOS_ASPIRANTES_INGLES_POR_CARRERA, {
            method: "POST",
            body: formData
        })
        .then((r) => r.blob())
        .then((d) => {
            const pdf = URL.createObjectURL(d);
            // window.open(pdf, "_blank");
            const anchor = document.createElement("a");
            // eslint-disable-next-line
            anchor.download = "PROMEDIOS DE RESULTADOS DE ASPIRANTES EN INGLÉS - " + nombre_carrera;
            anchor.href = pdf;
            anchor.click();
        })
        .catch(() => alert("Error al generar reporte"));

    };


    const promediosTodasCarreras = () => {
        elToast( "Generando reporte", "esperar" );

        const formData = new FormData();
        formData.append("ciclo", ciclo);
        console.log(ciclo);

        fetch(URL_PROMEDIOS_INGLES_TODAS_CARRERAS, {
            method: "POST",
            body: formData
        })
        .then((r) => r.blob())
        .then((d) => {
            const pdf = URL.createObjectURL(d);
            // window.open(pdf, "_blank");
            const anchor = document.createElement("a");
            anchor.download =
                "PROMEDIOS DE RESULTADOS DE ASPIRANTES EN INGLÉS - TODAS LAS CARRERAS";
            anchor.href = pdf;
            anchor.click();
        })
        .catch(() => alert("Error al generar reporte"));

    }


    useEffect(() => {
        traerCarreras();
        traerCiclosExamen()
      }, [])



    return {
        loading,
        carreras,
        promediosAspirantesIngles,
        promediosAspirantesInglesPorCarrera,
        promediosTodasCarreras,
        ciclo, setCiclo, ciclosExamen
    };

}

export default usePromediosResultadosIngles;